import React, { memo } from 'react';
import { di } from 'react-magnetic-di';
import { isFieldTypeSupported } from '@atlassian/ui-modifications-core/src/controllers/view-configuration';
import { useAdjustmentsEnabled } from '@atlassian/ui-modifications-core/controllers/adjustments-context';
import { REQUEST_CREATE_VIEW_TYPE } from '../../common/constants';
import { EnabledFieldDecorator } from './enabled-field-decorator';
import type { EnabledFieldDecoratorProps } from './enabled-field-decorator/types';

const FieldDecoratorAsyncNoMemo = ({ Component, componentProps }: EnabledFieldDecoratorProps) => {
	di(useAdjustmentsEnabled, EnabledFieldDecorator);
	const isUiModificationsEnabled = useAdjustmentsEnabled();

	const undecoratedComponent = <Component {...componentProps} />;

	if (!isUiModificationsEnabled) {
		return undecoratedComponent;
	}

	if (
		!isFieldTypeSupported(
			REQUEST_CREATE_VIEW_TYPE,
			componentProps.jiraFieldType ?? componentProps.id,
		)
	) {
		return undecoratedComponent;
	}

	return <EnabledFieldDecorator componentProps={componentProps} Component={Component} />;
};

export const FieldDecoratorAsync = memo(
	FieldDecoratorAsyncNoMemo,
) as typeof FieldDecoratorAsyncNoMemo;
